// extracted by mini-css-extract-plugin
export default {"legacyBrand":"Footer_legacyBrand__H1+mi","legacyFooterItem":"Footer_legacyFooterItem__QBFrN","legacyCopyright":"Footer_legacyCopyright__heAFw"};